import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" }
const _hoisted_2 = { class: "text-lg font-bold capitalize text-slate-900" }
const _hoisted_3 = { class: "max-h-[75vh] overflow-y-auto bg-white" }
const _hoisted_4 = { class: "divide-y divide-slate-100" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[200px_1fr] md:items-start" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[200px_1fr] md:items-start" }
const _hoisted_7 = { class: "mt-0.5 text-xs text-slate-400" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[200px_1fr] md:items-start" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_10 = ["max", "placeholder"]
const _hoisted_11 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[200px_1fr] md:items-start" }
const _hoisted_12 = { class: "mt-0.5 text-xs text-slate-400" }
const _hoisted_13 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[200px_1fr] md:items-start" }
const _hoisted_14 = { class: "inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 transition-colors cursor-pointer w-fit" }
const _hoisted_15 = { class: "flex items-center justify-end gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSelect = _resolveComponent("AppSelect")!

  return (_openBlock(), _createElementBlock("div", {
    class: "fixed inset-0 z-[999] flex items-center justify-center p-4 backdrop-blur-sm bg-slate-900/50",
    onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", {
      ref: "modalContent",
      class: "w-full max-w-[760px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl",
      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "Konfigurasi pesan pengingat otomatis via WhatsApp & Email.", -1))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("svg", {
              class: "h-5 w-5",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M6 18L18 6M6 6l12 12"
              })
            ], -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                  _createTextVNode("Nama Pengaturan "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ]),
                _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Judul internal untuk membedakan broadcast.")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                type: "text",
                class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                placeholder: "mis. Pengingat Iuran Wajib Bulanan"
              }, null, 512), [
                [_vModelText, _ctx.form.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                  _createTextVNode("Jenis Iuran "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _createElementVNode("p", _hoisted_7, "Variabel " + _toDisplayString(_ctx.jenisIuran) + " pada pesan.", 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.jenisIuran) = $event)),
                type: "text",
                class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                placeholder: "mis. Iuran Wajib Bulanan"
              }, null, 512), [
                [_vModelText, _ctx.form.jenisIuran]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                  _createTextVNode("Jadwal Pengiriman "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ]),
                _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Interval dan waktu eksekusi otomatis.")
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_AppSelect, {
                  modelValue: _ctx.form.scheduleInterval,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.scheduleInterval) = $event)),
                  options: [
                    { value: 'weekly', label: 'Mingguan' },
                    { value: 'monthly', label: 'Bulanan' },
                    { value: '3months', label: '3 Bulanan' }
                  ],
                  "button-class": "bg-slate-50 text-slate-800 focus:ring-blue-500/20"
                }, null, 8, ["modelValue"]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.scheduleDay) = $event)),
                  type: "number",
                  min: 1,
                  max: _ctx.form.scheduleInterval === 'weekly' ? 7 : 31,
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: _ctx.form.scheduleInterval === 'weekly' ? 'Hari ke- (1-7)' : 'Tanggal (1-31)'
                }, null, 8, _hoisted_10), [
                  [
                    _vModelText,
                    _ctx.form.scheduleDay,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                  _createTextVNode("Template Pesan "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _createElementVNode("p", _hoisted_12, "Gunakan " + _toDisplayString(_ctx.name) + " dan " + _toDisplayString(_ctx.jenisIuran) + " sebagai variabel dinamis.", 1)
              ]),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.template) = $event)),
                rows: "5",
                class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                placeholder: "Halo {{name}}, ini adalah pengingat pembayaran {{jenisIuran}} IOM ITB. Mohon segera melunasi iuran Anda. Terima kasih."
              }, null, 512), [
                [_vModelText, _ctx.form.template]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[18] || (_cache[18] = _createElementVNode("div", null, [
                _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Status Aktif"),
                _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Pesan akan dikirim otomatis jika aktif.")
              ], -1)),
              _createElementVNode("label", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.isActive) = $event)),
                  class: "h-4 w-4 rounded border-slate-300 text-blue-700 focus:ring-blue-500"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.isActive]
                ]),
                _cache[17] || (_cache[17] = _createTextVNode(" Jadwal Aktif ", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors"
          }, " Batal "),
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.isLoading,
            class: "rounded-lg bg-[#003793] px-6 py-2 text-sm font-bold text-white shadow-sm hover:bg-blue-800 transition-all disabled:cursor-not-allowed disabled:opacity-60"
          }, _toDisplayString(_ctx.isLoading ? 'Menyimpan...' : 'Simpan Pengaturan'), 9, _hoisted_16)
        ])
      ], 32)
    ], 512)
  ]))
}